import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export const taxConstraints = {
  name: plaintextValidator(config),
  rates: {
    array: {
      name: plaintextValidator(config),
      rateValue: plaintextValidator(config)
    }
  }
};
